export default __webpack_public_path__ + "static/media/r-architecture-Y8MJFQYYjh8-unsplash.1d73f3f6.jpg";